// Chip labels/prompts are user-visible (a clicked chip becomes the user's own
// bubble), so internal tool identifiers must never appear in them. The
// backend filters newly GENERATED chips; this mirrors that filter for chips
// already persisted in old transcripts (generated before the backend filter
// existed) and for any future backend gap.
const TOOL_NAME_MARKERS = [
  'kula_',
  'web_search',
  'web_grounded',
  'propose_clarify',
  'propose_plan',
  'present_table',
  'knowledge_search',
  'http_request',
];

export const leaksToolNames = (text: string): boolean => {
  const lower = text.toLowerCase();
  return TOOL_NAME_MARKERS.some((m) => lower.includes(m));
};
